import React, { FunctionComponent, useState } from "react";
import styles from "./VideoEmbed.module.scss";
import VideoEmbedProps from "./VideoEmbedProps.interface";

import combineClasses from "helpers/combine-classes";
import parseVideoUrl from "blocks/helpers/parseVideoUrl";
import YouTube from "react-youtube";
import IconViewer from "components/IconViewer/IconViewer";

const VideoEmbed: FunctionComponent<VideoEmbedProps> = (props) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [player, setPlayer] = useState<any>(undefined);

    const isPlayingClass = isPlaying === true ? styles.is_playing : undefined;
    const isAutoplay = props.autoplay ? props.autoplay : false;
    const isLoop = props.loop ? props.loop : false;

    const toggleVideoHandler = () => {
        if (typeof (player) !== "undefined") {
            const isPlayerPlaying = player.getPlayerState() === 1 ? true : false;
            setIsPlaying(!isPlaying);

            // Plays or pauses the current video
            { !isPlayerPlaying ? player.playVideo() : player.pauseVideo(); }
        }
    };

    const onReady = (event: any) => {
        setPlayer(event.target);
    };

    const onPlayerPlay = (event: any) => {
        setIsPlaying(true);
    };

    const onPlayerPause = (event: any) => {
        setIsPlaying(false);
    };

    return (
        <div className={styles.wrapper}>
            {/* Media */}
            {props.src ? (
                <YouTube
                    videoId={parseVideoUrl(props.src)}
                    opts={{
                        playerVars: {
                            autoplay: isAutoplay ? 1 : 0,
                            mute: isAutoplay ? 1 : 0, // Must mute to autoplay
                            color: "white",
                            controls: isAutoplay ? 0 : 1, // Hide controls on autoplay
                            rel: 0,
                            loop: isLoop ? 1 : 0,
                            showinfo: 0
                        }
                    }}
                    containerClassName={styles.video}
                    className={styles.iframe}
                    onReady={onReady}
                    onPlay={onPlayerPlay}
                    onPause={onPlayerPause}
                />
            ) : null}

            {!isAutoplay ? (
                <div className={combineClasses([styles.button_wrapper, isPlayingClass])} onClick={() => toggleVideoHandler()}>
                    <button aria-label="Play / Pause Video" type="button" className={styles.button}>
                        {!isPlaying ? (
                            <IconViewer name="play" className={styles.icon_play} />
                        ) : (
                            <IconViewer name="pause" className={styles.icon_pause} />
                        )}
                    </button>
                </div>
            ) : null}

            {typeof (props.aspectRatioX) !== "undefined" && typeof (props.aspectRatioY) !== "undefined" ? (
                <svg viewBox={`0 0 ${props.aspectRatioX} ${props.aspectRatioY}`} version="1.1" className={styles.ratio} preserveAspectRatio="xMidYMid" xmlSpace="preserve"></svg>
            ) : null}
        </div>
    );
};

export default VideoEmbed;